"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isOfLength = void 0;
var _isDefined = require("./isDefined");
var _number = require("../type-checks/number");
var isOfLength = exports.isOfLength = function isOfLength(target) {
  return (0, _isDefined.isDefined)(target) && ((0, _number.isNumber)(target) || Object.prototype.hasOwnProperty.call(target, "length") && target.length > 0);
};